import zhCN from './json/check-in.zh_CN.json';
import zhTW from './json/check-in.zh_TW.json';
import en from './json/check-in.en.json';
import ja from './json/check-in.ja.json';
import ko from './json/check-in.ko.json';
import ru from './json/check-in.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
